import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Component, ElementRef, HostListener, Input, Output, OnInit, ViewChild, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-search-expand',
  templateUrl: './search-expand.component.html',
  styleUrls: ['./search-expand.component.scss']
})
export class SearchExpandComponent implements OnInit {
  @Input() isExpanded: boolean;
  @Input() subSearch: boolean;
  @Output() isExpandedChange: EventEmitter<boolean> = new EventEmitter();
  @Output() searching: EventEmitter<string> = new EventEmitter();
  @Input() set setSearchText(value: string) {
    this.field = value;
  }

  changed: boolean;
  field: string;
  returnPath: string;
  searchField: ElementRef;
  @ViewChild('wrapper') wrapper: ElementRef;
  @ViewChild('searchField')
  set content(content: ElementRef) {
    this.searchField = content;
    if (this.searchField) {
      this.isExpanded = true;
      this.searchField.nativeElement.focus();
    }
  }

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    this.subscribeToRouteParam();
  }

  private subscribeToRouteParam(): void {
    this.route.queryParamMap.subscribe((params: ParamMap) => {
      if (!this.subSearch) {
        this.field = params.get('search');
        this.returnPath = params.get('return');
        if (this.router.url.includes('/search')) {
          setTimeout(() => this.inputShow());
        }
      }
    });
  }

  @HostListener('window:click', ['$event'])
  clickHandler(event) {
    let parent = event.target;
    while (!!parent && parent !== this.wrapper.nativeElement && parent !== document) {
      parent = parent.parentNode;
    }
    if (parent === document) {
      this.inputHide();
    }
  }

  search(): void {
    if (!this.isExpanded) {
      this.inputShow();
    } else {
      if (this.changed) {
        this.searchField.nativeElement.blur();
        this.changed = false;
      }
      if (this.subSearch) {
        this.searching.emit(this.field);
      } else {
        const returnPath = this.returnPath ||
          (this.router.url.includes('admin') ? document.location.pathname : null);
        this.router.navigate(
          ['search'],
          { queryParams: { search: this.field, return: returnPath }, relativeTo: this.route }
        );
      }
    }
  }

  change() {
    this.changed = true;
  }

  inputShow() {
    this.isExpandedChange.emit(true);
  }

  inputHide() {
    this.field = this.subSearch ? this.field : null;
    this.isExpandedChange.emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/search-expand/search-expand.component.ts